import { useRef, useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Menu from '../Screens/Employee/Menu/index';
import {
	BrowserRouter,
	Route,
	Routes,
	Link,
	useNavigate
} from "react-router-dom";
import {
	ClearLocal,
	GetLocal,
	GetParamsUrl,
	FetchService,
} from "./BaseControl";

let LogOut = false;

export async function EmployeeSessionCheckFetch(serviceName, inputValue, callServiceSuccessMethod, callServiceErrorMethod) {
	if (GetLocal("EmployeeSession") == undefined) {
		ClearLocal();
		window.location.href = "/";
		return false;
	}

	return new Promise((resolve) => {
		FetchService(
			"Employee/Security/CheckSession",
			{ session: GetLocal("EmployeeSession") },
			(serviceResult) => {
				if (serviceResult.entity === false) {
					ClearLocal();
					window.location.href = "/";
					resolve(false);
				} else {
					FetchService(serviceName, inputValue, callServiceSuccessMethod, callServiceErrorMethod)
					resolve(true);
				}
			},
			() => {
				ClearLocal();
				window.location.href = "/";
				resolve(false);
			}
		);
	});
}

export default function Home(props) {
	const [getUrbanName, setUrbanName] = useState('');
	const [getFileLogo, setFileLogo] = useState('');
	const navigate = useNavigate();

	useEffect(() => {
		NeedsLogin();
		GetLogo();
		GetUrbanName();
	}, []);

	window.navigation.addEventListener("navigate", (event) => {
		document.getElementsByTagName('body')[0].scrollTo(0, 0);
		if (!LogOut)
			NeedsLogin();
	});

	document.getElementsByTagName('body')[0].addEventListener('scroll', function () {
		document.getElementById("bdSidebar").style.height = document.body.scrollHeight + "px";
	});

	const NeedsLogin = (value) => {
		if (GetLocal('EmployeeSession') == undefined)
			CheckSessionFail();

		var inputValue = {
			session: GetLocal('EmployeeSession'),
		};
		FetchService("Employee/Security/CheckSession", inputValue, CheckSessionSuccess, CheckSessionFail);
	}

	const CheckSessionSuccess = (serviceResult) => {
		if (serviceResult.entity === false) {
			ClearLocal();
			window.location.href = "/";
		}

	}

	const CheckSessionFail = (serviceResult) => {
		LogOut = true;
		ClearLocal();
		window.location.href = "/";
	}



	const SignOutSuccess = () => {
		LogOut = true;
		ClearLocal();
		window.location.href = "/";
	}

	const SignOut = () => {
		let input = { session: GetLocal('EmployeeSession') }
		FetchService("Employee/Security/Logout", input, SignOutSuccess);

	}

	const GetLogo = () => {
		var inputValue = {session: GetLocal('EmployeeSession'),};
		FetchService("Employee/General/GetLogo", inputValue, GetLogoSuccess);
	}

	const GetLogoSuccess = (serviceResult) => {
		setFileLogo(serviceResult.entity);
	}

	const GetUrbanName = () => {
		var inputValue = {session: GetLocal('EmployeeSession')};
		FetchService("Employee/General/GetUrbanName", inputValue, GetUrbanNameSuccess);
	}

	const GetUrbanNameSuccess = (serviceResult) => {
		setUrbanName(serviceResult.entity);
	}

	return (
		<div class="container-fluid p-0 d-flex h-100" dir="rtl" style={{ background: "#f8f9fa" }}>
			<div id="bdSidebar"
				class="d-flex flex-column
				flex-shrink-0
				p-3 bg-dark
				text-white offcanvas-md offcanvas-start">
				<img src={"data:image/png;base64," + getFileLogo} style={{ width: "120px", margin: "10px auto" }} />
				<a href="#"
					class="navbar-brand text-center text-sm">
					{getUrbanName}
				</a>

				<div href="#" class="navbar-brand text-center text-sm">
					<br />
					<span style={{ color: '#affffc' }}>{GetLocal('FullName')} <br /> {GetLocal('RoleInfo')} </span>
				</div>

				<hr />

				<Menu />

				<br />
				<hr />
			</div>

			<div class="flex-fill">
				<div id="ckIcon" class="p-2 d-md-none d-flex text-white bg-dark">
					<a href="#" class="text-white"
						data-bs-toggle="offcanvas"
						data-bs-target="#bdSidebar">
						<i class="fa fa-bars text-warning"></i>
					</a>
					<span class="ms-3">سامانه کاربران</span>
				</div>
				<div class="p-4 container-fluid">
					<nav>
						<div class="d-flex w-100 justify-content-between">
							<div>
								<div className="text-decoration-none my-2">
									<i class="fa fa-home mx-2 text-dark align-middle"></i>
									<span class="text-dark">سامانه کاربران {getUrbanName} / <span className="text-primary">{GetParamsUrl('page')}</span></span>
								</div>
							</div>
							<div>
								<Link onClick={SignOut} className="text-decoration-none text-danger btn btn-danger">
									<span class="text-white">خروج</span>
									<i class="fa fa-sign-out mx-2 text-white align-middle"></i>
								</Link>
							</div>
						</div>
					</nav>

					<hr />

					<div className="bg-white border p-2">
						<Outlet />
					</div>
				</div>
			</div>
		</div>
	);
}
